import { render, staticRenderFns } from "./EnergyInvestment.vue?vue&type=template&id=1bafee92&scoped=true&"
import script from "./EnergyInvestment.vue?vue&type=script&lang=js&"
export * from "./EnergyInvestment.vue?vue&type=script&lang=js&"
import style0 from "./EnergyInvestment.vue?vue&type=style&index=0&id=1bafee92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bafee92",
  null
  
)

export default component.exports